import { useEffect } from 'react';
import { ResolvedTheme } from '../context/ThemeContext';
import { THEMES } from '../theme/registry';

const LINK_ID = 'primereact-theme';

function themeUrl(theme: ResolvedTheme): string {
    return `${process.env.PUBLIC_URL}/primereact-themes/${THEMES[theme].primereact}/theme.css`;
}

function getOrCreateLink(): HTMLLinkElement {
    let link = document.getElementById(LINK_ID) as HTMLLinkElement | null;
    if (!link) {
        link = document.createElement('link');
        link.id = LINK_ID;
        link.rel = 'stylesheet';
        document.head.appendChild(link);
    }
    return link;
}

function preloadTheme(href: string) {
    const existing = document.querySelector(`link[rel="preload"][href="${href}"]`);
    if (!existing) {
        const preload = document.createElement('link');
        preload.rel = 'preload';
        preload.as = 'style';
        preload.href = href;
        document.head.appendChild(preload);
    }
}

export default function usePrimeReactTheme(theme: ResolvedTheme) {
    // Preload all known PrimeReact themes on mount to avoid FOUC when switching
    useEffect(() => {
        Object.keys(THEMES).forEach((name) => {
            preloadTheme(themeUrl(name as ResolvedTheme));
        });
    }, []);

    // Switch theme when resolved theme changes
    useEffect(() => {
        const link = getOrCreateLink();
        link.href = themeUrl(theme);
    }, [theme]);
}
